(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[94625],{

/***/ 49609:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contentintelligence",
      function () {
        return __webpack_require__(37615);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 37615:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ ContentIntelligenceHome; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_layouts_contentIntelligenceWrapper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37486);
/* harmony import */ var _components_contentintelligence_homePage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32791);




var __N_SSP = true;
function ContentIntelligenceHome() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_layouts_contentIntelligenceWrapper__WEBPACK_IMPORTED_MODULE_2__["default"], {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_contentintelligence_homePage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
    });
}


/***/ }),

/***/ 32791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ HomePage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/shared/form/index.tsx
var shared_form = __webpack_require__(96119);
// EXTERNAL MODULE: ./src/components/contentintelligence/mainBanner/styles.module.scss
var styles_module = __webpack_require__(21521);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./src/styles/variables/contentintelligenceVariables.module.scss
var contentintelligenceVariables_module = __webpack_require__(21076);
var contentintelligenceVariables_module_default = /*#__PURE__*/__webpack_require__.n(contentintelligenceVariables_module);
;// CONCATENATED MODULE: ./src/components/svg/checkCircleIcon.tsx


function Icon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "15",
        height: "15",
        fill: "none",
        viewBox: "0 0 15 15",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "7.5",
                cy: "7.5",
                r: "7.5",
                fill: "#000"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                stroke: "#fff",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2",
                d: "M4.375 7.948l1.989 1.989 4.198-4.198"
            })
        ]
    });
}
/* harmony default export */ var checkCircleIcon = (Icon);

// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/lib/sharedUtils.ts
var sharedUtils = __webpack_require__(75094);
// EXTERNAL MODULE: ./src/components/shared/textBlockOffer/TextBlockOffer.tsx
var TextBlockOffer = __webpack_require__(45464);
;// CONCATENATED MODULE: ./src/components/contentintelligence/mainBanner/index.tsx










function MainBanner() {
    const sellingPoints = [
        "Capture and secure your documents from day one.",
        "Track and leverage your valuable information.",
        "Content is available to everyone you've authorized.",
        "Automate repetitive tasks so your documents, approvals, and actionable items get to the right people at the right time.", 
    ];
    const router = (0,next_router.useRouter)();
    const { domain  } = (0,useDomainContext/* useDomainContext */.w)();
    const isFormDisplayed = (0,sharedUtils/* finalShowForm */.r6)(router.query.sl, domain.showForm, domain.defaultOffers);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isFormDisplayed ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (styles_module_default())["main-banner"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (styles_module_default()).intro,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                            children: [
                                "Start Your Organization's Digital Transformation",
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Through powerful workflows, electronic forms, document management and analytics, our platform eliminates manual processes and automates repetitive tasks, accelerating how business gets done in a secure way."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Our top-rated enterprise content management companies can help you enjoy the following benefits:"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            children: sellingPoints.map((point, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(checkCircleIcon, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: point
                                        })
                                    ]
                                }, index))
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_form/* default */.Z, {
                    classes: {
                        formClassName: (styles_module_default()).form,
                        stepTitleClassName: (styles_module_default())["step-title"],
                        stepClassName: (styles_module_default())["step-block"],
                        stepDescriptionClassName: (styles_module_default())["step-description"],
                        formButtonClassName: (styles_module_default())["form-button"],
                        formFieldClassName: (styles_module_default())["form-field"],
                        formStepInnerClassName: (styles_module_default())["steps-inner"],
                        fieldsClassName: {
                            radio: (styles_module_default())["radio-field"],
                            checkbox: (styles_module_default())["checkbox-field"]
                        },
                        fieldsWrapperClassName: (styles_module_default())["fields-wrapper"],
                        tcpaClassName: (styles_module_default()).tcpa,
                        labelAsTitleClassName: (styles_module_default())["label-as-step-title"],
                        sellingPointClassName: (styles_module_default())["selling-point"]
                    },
                    colors: {
                        primaryColor: (contentintelligenceVariables_module_default()).purple,
                        progressBar: (contentintelligenceVariables_module_default()).grey
                    },
                    showProgress: true,
                    preventWindowClose: true
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TextBlockOffer/* default */.Z, {})
    });
}

;// CONCATENATED MODULE: ./src/components/contentintelligence/homePage/index.tsx





const ProductiveTools = dynamic_default()(()=>__webpack_require__.e(/* import() */ 12434).then(__webpack_require__.bind(__webpack_require__, 12434)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(12434)
            ]
    }
});
const WhyUs = dynamic_default()(()=>__webpack_require__.e(/* import() */ 56565).then(__webpack_require__.bind(__webpack_require__, 56565)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(56565)
            ]
    }
});
const EcmDetails = dynamic_default()(()=>__webpack_require__.e(/* import() */ 8784).then(__webpack_require__.bind(__webpack_require__, 8784)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(8784)
            ]
    }
});
const MakeItEasy = dynamic_default()(()=>__webpack_require__.e(/* import() */ 50660).then(__webpack_require__.bind(__webpack_require__, 50660)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(50660)
            ]
    }
});
const OffersList = dynamic_default()(()=>Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 33124)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(33124)
            ]
    }
});
function HomePage() {
    const { domain  } = (0,useDomainContext/* useDomainContext */.w)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainBanner, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OffersList, {
                    offers: domain?.defaultOffers
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WhyUs, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EcmDetails, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MakeItEasy, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductiveTools, {})
        ]
    });
}


/***/ }),

/***/ 21521:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","main-banner":"styles_main-banner__E38Ph","form":"styles_form__Ls62X","steps-inner":"styles_steps-inner__ZgCY9","step-title":"styles_step-title__2gll0","label-as-step-title":"styles_label-as-step-title__iwQrP","step-description":"styles_step-description__REmSv","fields-wrapper":"styles_fields-wrapper__jkdMi","form-button":"styles_form-button__LXJXu","form-field":"styles_form-field__717C5","radio-field":"styles_radio-field__L7HL_","checkbox-field":"styles_checkbox-field__AhDa4","tcpa":"styles_tcpa__pjfue","intro":"styles_intro__wbhK3","step-block":"styles_step-block__q_YwO","selling-point":"styles_selling-point__9zFmi"};

/***/ }),

/***/ 21076:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"purple":"#51378e","orangeLight":"#f1c19c","orangeHover":"#f1dfd0","orange":"#df8d46","grey":"#b0b0b0"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [92592,10621,12672,88566,37486,49774,92888,40179], function() { return __webpack_exec__(49609); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);